import { render, staticRenderFns } from "./ActivityChangesDialog.vue?vue&type=template&id=670adb82&scoped=true"
import script from "./ActivityChangesDialog.vue?vue&type=script&lang=js"
export * from "./ActivityChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./ActivityChangesDialog.vue?vue&type=style&index=0&id=670adb82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670adb82",
  null
  
)

export default component.exports